import styled from '@emotion/styled';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { type HTMLSpanProps } from '@/lib/types';
import { CHALLENGE_NULL_COLOR } from '../../ChallengeView/ChallengeColorBar';

type StyledPhaseTextProps = HTMLSpanProps & {
  challengeColor: string | null;
};

const StyledPhaseText = styled('span')<StyledPhaseTextProps>(
  ({ theme, challengeColor }) => ({
    marginBottom: 6,
    color:
      challengeColor && challengeColor !== CHALLENGE_NULL_COLOR
        ? theme.palette.getContrastText(challengeColor)
        : theme.palette.text.secondary,
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    outline: `2px solid ${theme.palette.background.paper}`,
  })),
);

export default StyledPhaseText;
